import React, { useState, useEffect, useRef } from "react";
import toast from "react-hot-toast";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import TrashIcon from "@mui/icons-material/DeleteRounded";
import DatePicker from "react-datepicker";
import {
    fetchPolicyGroups,
    fetchAnnouncements,
    deleteAnnouncement,
    saveAnnouncement,
    uploadAnnouncementImage,
    deleteAnnouncementImage,
    fetchOrganizationDevices,
} from "js/Api/index";
import SendToModal from "js/Component/SendToModal";
import { Button } from '../../Component/CommonFormEle';

function Announcements({ resetFlag, org }) {
    const [groups, setGroups] = useState();
    const [announcements, setAnnouncements] = useState([]);
    const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteAnnouncementId, setDeleteAnnouncementId] = useState(null);
    const [isFamilyorg, setisFamilyorg] = useState(org?.orgType === "family" ? true : false);
    const [announcementTitle, setannouncementTitle] = useState(org?.orgType === "family" ? "Text Announcements" : "Announcements");

    useEffect(() => {
        setSelectedAnnouncement(null);
        setShowModal(false);
        setShowDeleteModal(false);
        setDeleteAnnouncementId(null);
    }, [resetFlag]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                await Promise.all([fetchPolicyGroupsData(), fetchAnnouncementsData()]);
            } catch (error) {
                console.error("Error fetching initial data:", error);
            }
        };

        if (org.id) {
            fetchData();
        }
    }, [org.id]);

    const fetchPolicyGroupsData = async () => {
        try {
            const response = await fetchPolicyGroups(org.id);
            if (response.success) {
                setGroups(response.data);
            } else {
                console.error("Failed to fetch policy groups:", response.error);
            }
        } catch (error) {
            console.error("Failed to fetch policy groups:", error);
        }
    };

    const fetchAnnouncementsData = async () => {
        try {
            const response = await fetchAnnouncements(org.id);
            if (response.success) {
                setAnnouncements(response.data);
            } else {
                console.error("Failed to fetch announcements:", response.error);
            }
        } catch (error) {
            console.error("Failed to fetch announcements:", error);
        }
    };

    const handleAddClick = () => {
        setSelectedAnnouncement(null);
        setShowModal(true);
    };

    const handleAnnouncementSend = async (updatedAnnouncement) => {
        try {
            await fetchAnnouncementsData();
            setShowModal(false);
            toast.success(
                selectedAnnouncement
                    ? "Announcement updated successfully!"
                    : "Announcement created successfully!"
            );
        } catch (error) {
            console.log("Error:", error);
            toast.error("Failed to refresh announcements. Please try again.");
        }
    };

    const handleDeleteAnnouncementClick = (deleteAnnouncementId) => {
        if (deleteAnnouncementId) {
            setDeleteAnnouncementId(deleteAnnouncementId);
            setShowDeleteModal(true);
        }
    };

    const handleDeleteAnnouncementCancel = () => {
        setShowDeleteModal(false);
    };

    const handleDeleteAnnouncementConfirm = async () => {
        try {
            const response = await deleteAnnouncement(deleteAnnouncementId);
            if (response.success) {
                setAnnouncements(
                    announcements.filter(
                        (announcement) => announcement.id !== deleteAnnouncementId
                    )
                );
                setShowDeleteModal(false);
                toast.success("Announcement deleted!");
                await fetchAnnouncementsData();
            } else {
                toast.error(
                    response.error || "Failed to delete announcement. Please try again"
                );
            }
        } catch (error) {
            toast.error("Failed to delete announcement. Please try again");
            console.error("Error:", error);
        }
    };

    const handleClickRow = (selectedAnnouncementId) => {
        const announcement = announcements.find(
            (a) => a.id === selectedAnnouncementId
        );
        const policyGroupIds = announcement.group
            ? announcement.group.map((g) => g.policyGroupId)
            : [];
        setSelectedAnnouncement({ ...announcement, policyGroupIds });
        setShowModal(true);
    };

    function parseISOString(isoString) {
        const parts = isoString.match(/\d+/g);
        return new Date(
            Date.UTC(
                parseInt(parts[0], 10),
                parseInt(parts[1], 10) - 1,
                parseInt(parts[2], 10),
                parseInt(parts[3], 10),
                parseInt(parts[4], 10),
                parseInt(parts[5], 10)
            )
        );
    }

    function formatDateToReadable(date) {
        return date.toLocaleString("en-AU", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    }

    const formatDate = (isoString) => {
        const date = parseISOString(isoString);
        return formatDateToReadable(date);
    };

    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) return text;
        return text.slice(0, maxLength - 3) + "...";
    };

    const getRecipientText = (announcement) => {
        switch (announcement.sentTo) {
            case "every_one":
                return "Everyone";
            case "policy_group":
                const groupNames = announcement.group.map((g) => g.name).join(", ");
                return `Group(s): ${truncateText(groupNames, 30)}`;
            case "device":
                const deviceNames = announcement.devices.map((d) => d.name).join(", ");
                return `Device(s): ${truncateText(deviceNames, 30)}`;
            default:
                return announcement.sentTo;
        }
    };

    return (
        <>
            <div className="midde_cont">
                <div
                    className="container-fluid"
                    style={{ paddingLeft: "0", paddingRight: "0" }}
                >
                    <div className="row column_title">
                        <div className="col-md-12">
                            <div className="page_title">
                                <h2>{announcementTitle}</h2>
                            </div>
                        </div>
                    </div>
                    {showModal ? (
                        <EditAnnouncement
                            org={org}
                            onBackClick={() => {
                                setShowModal(false);
                                fetchAnnouncements();
                            }}
                            announcementTitle={announcementTitle}
                            isFamilyorg={isFamilyorg}
                            onSend={handleAnnouncementSend}
                            selectedAnnouncement={selectedAnnouncement}
                            groups={groups}
                        />
                    ) : (
                        <>
                            <div class="white_shd full margin_bottom_30">
                                <div class="full inner_elements">
                                    <div class="padding_infor_info">
                                        <Button onClick={handleAddClick} variant="action-popup">
                                            New {announcementTitle}
                                        </Button>
                                        <div class="clear"></div>
                                        <br />
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="table-wrap">
                                                    <table className="table table-responsive-xl table-hover">
                                                        <thead>
                                                            <tr key="header">
                                                                {/* <th>Subject</th> */}
                                                                <th>Body</th>
                                                                <th>Start Time</th>
                                                                <th>End Time</th>
                                                                <th>Recipient</th>
                                                                <th>&nbsp;</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {announcements?.map((announcement) => (
                                                                <tr
                                                                    key={announcement.id}
                                                                    onClick={() =>
                                                                        handleClickRow(announcement.id)
                                                                    }
                                                                >
                                                                    <td>{truncateText(announcement.body, 30)}</td>
                                                                    <td>{formatDate(announcement.startTime)}</td>
                                                                    <td>{formatDate(announcement.endTime)}</td>
                                                                    <td>{getRecipientText(announcement)}</td>
                                                                    <td>
                                                                        <TrashIcon
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                handleDeleteAnnouncementClick(
                                                                                    announcement.id
                                                                                );
                                                                            }}
                                                                            style={{
                                                                                fontSize: "1rem",
                                                                                color: "black",
                                                                                marginRight: "10px",
                                                                                cursor: "pointer",
                                                                            }}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>

            {showDeleteModal && (
                <div
                    className="modal fade show"
                    style={{ display: "block" }}
                    aria-modal="true"
                    role="dialog"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Delete {announcementTitle}</h5>
                                <Button onClick={handleDeleteAnnouncementCancel} variant="modal-close">
                                    &times;
                                </Button>
                            </div>
                            <div className="modal-body">
                                <p>
                                    Are you sure you want to delete{" "}
                                    <strong>
                                        {
                                            announcements.find(
                                                (announcement) =>
                                                    announcement.id === deleteAnnouncementId
                                            )?.subject
                                        }
                                    </strong>
                                    ?
                                </p>
                            </div>
                            <div className="modal-footer">
                                <Button onClick={handleDeleteAnnouncementCancel} variant="cancel">
                                    Cancel
                                </Button>
                                <Button onClick={handleDeleteAnnouncementConfirm} variant="delete">
                                    Delete
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

function EditAnnouncement({
    onBackClick,
    onSend,
    selectedAnnouncement,
    groups,
    org,
    announcementTitle,
    isFamilyorg
}) {
    const getCurrentDate = () => new Date();
    const getDefaultEndDate = () =>
        new Date(getCurrentDate().getTime() + 24 * 60 * 60 * 1000);

    const newAnnouncement = {
        id: crypto.randomUUID(),
        organizationId: org.id,
        subject: "",
        body: "",
        sentTo: "",
        startTime: getCurrentDate(),
        endTime: getDefaultEndDate(),
        policyGroupIds: [],
        devices: [],
    };

    const [announcement, setAnnouncement] = useState(() => {
        if (selectedAnnouncement) {
            return {
                ...selectedAnnouncement,
                startTime: parseISOString(selectedAnnouncement.startTime),
                endTime: selectedAnnouncement.endTime
                    ? parseISOString(selectedAnnouncement.endTime)
                    : null,
                policyGroupIds: selectedAnnouncement.policyGroupIds || [],
            };
        }
        return newAnnouncement;
    });

    const [selectedItems, setSelectedItems] = useState([]);
    const [itemPicker, setItemPicker] = useState(false);
    const [items, setItems] = useState([]);
    const [displayItems, setDisplayItems] = useState([]);
    const [sendTo, setSendTo] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [selectAll, setSelectAll] = useState(false);
    const [subjectCharCount, setSubjectCharCount] = useState(0);
    const [bodyCharCount, setBodyCharCount] = useState(0);
    const [displayTarget, setDisplayTarget] = useState([]);
    const [timeError, setTimeError] = useState("");
    const [error, setError] = useState("");
    const [subjectError, setSubjectError] = useState("");
    const [bodyError, setBodyError] = useState("");
    const [existingImage, setExistingImage] = useState(null);
    const [isImageDeleted, setIsImageDeleted] = useState(false);

    //new status for attach image
    const [selectedImage, setSelectedImage] = useState(null);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const fileInputRef = useRef(null);
    const [isLoadingData, setIsLoadingData] = useState(false);

    useEffect(() => {
        if (selectedAnnouncement) {
            setSendTo(selectedAnnouncement.sentTo);
            if (selectedAnnouncement.sentTo === "device") {
                const deviceIds = selectedAnnouncement.devices.map(
                    (device) => device.deviceId
                );
                setSelectedItems(deviceIds);
                setDisplayItems(
                    selectedAnnouncement.devices.map((device) => device.name)
                );
                setDisplayTarget("Devices");
            } else if (selectedAnnouncement.sentTo === "policy_group") {
                const groupIds = selectedAnnouncement.group.map(
                    (group) => group.policyGroupId
                );
                setSelectedItems(groupIds);
                setDisplayItems(selectedAnnouncement.group.map((group) => group.name));
                setDisplayTarget("Groups");
            } else if (selectedAnnouncement.sentTo === "all_policy_group") {
                setDisplayTarget("All Groups");
            }
            else if (selectedAnnouncement.sentTo === "every_one") {
                setDisplayTarget("Every One");
            }

            if (
                selectedAnnouncement.images &&
                selectedAnnouncement.images.length > 0
            ) {
                setExistingImage(selectedAnnouncement.images[0]);
                setIsImageDeleted(false);
                setSelectedImage(null);
            }
        }
    }, [selectedAnnouncement]);

    useEffect(() => {
        const fetchItems = async () => {
            setIsLoadingData(true);
            try {
                if (sendTo === "device") {
                    const response = await fetchOrganizationDevices(org.code, false);
                    if (response.success) {
                        setItems(response.data);
                    } else {
                        console.error("Failed to fetch devices:", response.error);
                    }
                } else if (sendTo === "policy_group") {
                    setItems(groups);
                }
                setIsLoadingData(false);
            } catch (error) {
                console.error(`Failed to fetch ${sendTo}s:`, error);
            }
        };

        if (itemPicker) {
            fetchItems();
        }
    }, [itemPicker, sendTo, org.code, groups]);

    useEffect(() => {
        if (selectedAnnouncement) {
            setSubjectCharCount(selectedAnnouncement.subject.length);
            setBodyCharCount(selectedAnnouncement.body.length);
        }
    }, [selectedAnnouncement]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "subject") {
            if (value.length <= 20) {
                setAnnouncement({ ...announcement, [name]: value });
                setSubjectCharCount(value.length);
                setSubjectError("");
            } else {
                setSubjectError(
                    "Too many characters. Please keep the text up to 20 characters long."
                );
            }
        } else if (name === "body") {
            if (value.length <= 120) {
                setAnnouncement({ ...announcement, [name]: value });
                setBodyCharCount(value.length);
                setBodyError("");
            } else {
                setBodyError(
                    "Too many characters. Please keep the text up to 120 characters long."
                );
            }
        }
    };

    const handleItemSelect = (itemId) => {
        setSelectedItems((prevSelectedItems) =>
            prevSelectedItems.includes(itemId)
                ? prevSelectedItems.filter((id) => id !== itemId)
                : [...prevSelectedItems, itemId]
        );
    };

    const handleSelectItem = (type) => {
        if (sendTo !== type) {
            setSelectedItems([]);
            setDisplayItems([]);
        }
        setSendTo(type);
        setItemPicker(true);
    };

    const handleDateChange = (date, field) => {
        const now = new Date();
        if (field === "startTime") {
            if (date < now) {
                setTimeError("Start Time cannot be in the past");
                return;
            }
            const oneYearLater = new Date(date.getTime() + 365 * 24 * 60 * 60 * 1000);
            setAnnouncement((prev) => ({
                ...prev,
                startTime: date,
                endTime:
                    prev.endTime && date >= prev.endTime
                        ? new Date(date.getTime() + 24 * 60 * 60 * 1000)
                        : prev.endTime > oneYearLater
                            ? oneYearLater
                            : prev.endTime,
            }));
            setTimeError("");
        } else if (field === "endTime") {
            const oneYearLater = new Date(
                announcement.startTime.getTime() + 365 * 24 * 60 * 60 * 1000
            );
            if (date <= announcement.startTime) {
                setTimeError("End Time must be after Start Time");
            } else if (date > oneYearLater) {
                setTimeError("End Time cannot be more than one year after Start Time");
            } else {
                setAnnouncement((prev) => ({ ...prev, endTime: date }));
                setTimeError("");
            }
        }
    };

    // Function to get the end of the day
    const getEndOfDay = (date) => {
        const endOfDay = new Date(date);
        endOfDay.setHours(23, 59, 59, 999);
        return endOfDay;
    };

    // Functions for attack image
    const handleImageSelect = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file.size > 10 * 1024 * 1024) {
                alert("Image size should not exceed 10MB");
                return;
            }

            const reader = new FileReader();
            reader.onloadend = () => {
                setSelectedImage({
                    file: file,
                    preview: reader.result,
                });
            };
            reader.readAsDataURL(file);
        }
    };

    const handleImageClick = () => {
        setShowDeleteDialog(true);
    };

    const handleRemoveImage = () => {
        setSelectedImage(null);
        setShowDeleteDialog(false);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    // 添加处理删除现有图片的函数
    const handleRemoveExistingImage = () => {
        setIsImageDeleted(true);
        setExistingImage(null);
        setShowDeleteDialog(false);
    };

    const handlePostAnnouncement = async (e) => {
        if (e && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }
        if (!sendTo) {
            setError("Please select targets");
            return;
        }
        if (!announcement.body.trim()) {
            setError("Body is required");
            return;
        }

        setError("");

        try {
            // 1. Delete existing image if needed
            if (
                selectedAnnouncement &&
                isImageDeleted &&
                selectedAnnouncement.images?.[0]
            ) {
                const deleteResponse = await deleteAnnouncementImage(
                    selectedAnnouncement.id,
                    selectedAnnouncement.images[0].id
                );

                if (!deleteResponse.success) {
                    setError(deleteResponse.error || "Failed to delete existing image");
                    return;
                }
            }

            // 2. Prepare announcement data
            const requestBody = {
                id: announcement.id,
                organizationId: announcement.organizationId,
                subject: announcement.subject,
                body: announcement.body,
                sentTo: sendTo,
                startTime: announcement.startTime.toISOString(),
                endTime: announcement.endTime.toISOString(),
                policyGroupIds: sendTo === "policy_group" ? selectedItems : [],
                devices: sendTo === "device" ? selectedItems : [],
            };

            // 3. Save the announcement
            const saveResponse = await saveAnnouncement(
                requestBody,
                !!selectedAnnouncement
            );

            if (!saveResponse.success) {
                setError(saveResponse.error || "Failed to save announcement");
                return;
            }

            // 4. Upload new image if selected
            if (selectedImage) {
                let announcementId = selectedAnnouncement
                    ? announcement.id
                    : saveResponse.data.id;

                const uploadResponse = await uploadAnnouncementImage(
                    announcementId,
                    selectedImage.file
                );

                if (!uploadResponse.success) {
                    console.error("Image upload failed:", uploadResponse.error);
                    setError("Announcement created but image upload failed");
                    // Continue with success since announcement was created
                }
            }

            onSend();
        } catch (error) {
            console.error("Error:", error);
            setError("An error occurred while processing your request");
        }
    };

    const filteredItems = items.filter(
        (item) =>
            item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            (item.serialNo &&
                item.serialNo.toLowerCase().includes(searchQuery.toLowerCase()))
    );

    const handleSelectAll = () => {
        setSelectAll(!selectAll);
        if (!selectAll) {
            setSelectedItems(filteredItems.map((item) => item.id));
        } else {
            setSelectedItems([]);
        }
    };

    const handleCancel = () => {
        setItemPicker(false);
        setSearchQuery("");
        setSelectAll(false);
    };

    const handleConfirm = () => {
        setItemPicker(false);
        setAnnouncement((prev) => ({
            ...prev,
            policyGroupIds: sendTo === "policy_group" ? selectedItems : [],
            devices: sendTo === "device" ? selectedItems : [],
        }));
        // Update displayItems based on the selected items
        if (sendTo === "device") {
            const selectedDevices = items.filter((item) =>
                selectedItems.includes(item.id)
            );
            setDisplayItems(selectedDevices.map((device) => device.name));
        } else if (sendTo === "policy_group") {
            const selectedGroups = groups.filter((group) =>
                selectedItems.includes(group.id)
            );
            setDisplayItems(selectedGroups.map((group) => group.name));
        }
    };

    function parseISOString(isoString) {
        const parts = isoString.match(/\d+/g);
        return new Date(
            Date.UTC(
                parseInt(parts[0], 10),
                parseInt(parts[1], 10) - 1,
                parseInt(parts[2], 10),
                parseInt(parts[3], 10),
                parseInt(parts[4], 10),
                parseInt(parts[5], 10)
            )
        );
    }

    const displaySelectedItems =
        displayItems.length > 0
            ? displayItems.slice(0, 5).join(", ") +
            (displayItems.length > 5 ? "..." : "")
            : null;

    return (
        <div
            className="white_shd full margin_bottom_30"
            style={{ padding: "40px" }}
        >
            <div className="col-md-6" style={{ padding: 0 }}>
                <form className="contact-form">
                    <div className="form-group" style={{ display: "inline" }}>
                        <ArrowBackRoundedIcon
                            onClick={onBackClick}
                            sx={{
                                fontSize: "2rem",
                                color: "black",
                                cursor: "pointer",
                                marginLeft: "0",
                                marginTop: "0",
                            }}
                        />
                        &nbsp;&nbsp;
                        <h2 style={{ display: "inline" }}>
                            {selectedAnnouncement ? "Edit " : "New "} {announcementTitle}
                        </h2>
                    </div>
                    <div className="form-group">
                        <label>&nbsp;</label>
                    </div>
                    <div className="form-group">
                        <label htmlFor="body">Body</label>
                        <textarea
                            className="form-control"
                            id="body"
                            name="body"
                            style={{
                                height: 150,
                                overflowY: "scroll",
                                resize: "none",
                                scrollbarColor: "#007bff",
                            }}
                            value={announcement.body}
                            onChange={handleInputChange}
                            placeholder="Enter the text"
                        />
                        <small>{`${bodyCharCount}/120 characters`}</small>
                        {bodyError && (
                            <div className="error-message" style={{ color: "red" }}>
                                {bodyError}
                            </div>
                        )}
                    </div>

                    <div className="form-group">
                        {existingImage && !isImageDeleted && (
                            <div style={{ marginTop: 15 }}>
                                <img
                                    src={existingImage.fileName}
                                    alt="Current"
                                    style={{
                                        maxWidth: "200px",
                                        maxHeight: "200px",
                                        cursor: "pointer",
                                        border: "1px solid #ddd",
                                        borderRadius: "4px",
                                        padding: "5px",
                                    }}
                                    onClick={() => setShowDeleteDialog(true)}
                                />
                                <div style={{ marginTop: 5 }}>
                                    <small style={{ color: "#666" }}>
                                        {" "}
                                        Click image to remove{" "}
                                    </small>
                                </div>
                            </div>
                        )}

                        {selectedImage && (
                            <div style={{ marginTop: 15 }}>
                                <img
                                    src={selectedImage.preview}
                                    alt="Preview"
                                    style={{
                                        maxWidth: "200px",
                                        maxHeight: "200px",
                                        cursor: "pointer",
                                        border: "1px solid #ddd",
                                        borderRadius: "4px",
                                        padding: "5px",
                                    }}
                                    onClick={() => setShowDeleteDialog(true)}
                                />
                                <div style={{ marginTop: 5 }}>
                                    <small style={{ color: "#666" }}>
                                        {" "}
                                        Click image to remove{" "}
                                    </small>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="form-group">
                        <label>Send to</label>
                        {selectedAnnouncement ? (
                            <div>{displayTarget}</div>
                        ) : (
                            <div>
                                <label htmlFor="all_policy_group" style={{ marginRight: 70 }}>
                                    <input
                                        type="radio"
                                        name="sendTo"
                                        id="every_one"
                                        style={{ marginRight: 5, accentColor: "#007bff" }}
                                        value="every_one"
                                        checked={sendTo === "every_one"}
                                        onChange={() => {
                                            setSendTo("every_one");
                                            setSelectedItems([]);
                                            setDisplayItems([]);
                                        }}
                                    />
                                    Everyone
                                </label>
                                {!isFamilyorg &&
                                    <label htmlFor="policy_group" style={{ marginRight: 70 }}>
                                        <input
                                            type="radio"
                                            name="sendTo"
                                            id="policy_group"
                                            style={{ marginRight: 5, accentColor: "#007bff" }}
                                            value="policy_group"
                                            checked={sendTo === "policy_group"}
                                            onChange={() => handleSelectItem("policy_group")}
                                        />
                                        Select Device Groups
                                    </label>
                                }
                                <label htmlFor="device">
                                    <input
                                        type="radio"
                                        name="sendTo"
                                        id="device"
                                        style={{ marginRight: 5, accentColor: "#007bff" }}
                                        value="device"
                                        checked={sendTo === "device"}
                                        onChange={() => handleSelectItem("device")}
                                    />
                                    Select Devices
                                </label>
                            </div>
                        )}
                    </div>

                    {(sendTo === "policy_group" || sendTo === "device") && (
                        <div className="form-group" style={{ marginBottom: 20 }}>
                            <label style={{ fontWeight: 400, fontSize: 16 }}>
                                Selected {sendTo === "policy_group" ? "groups" : "devices"}:
                            </label>
                            <div>{displaySelectedItems}</div>
                            <button
                                type="button"
                                className="btn cur-p btn-dark"
                                onClick={() => setItemPicker(true)}
                                style={{ marginTop: 10, width: "135px" }}
                            >
                                {" "}
                                Modify Selection{" "}
                            </button>
                        </div>
                    )}

                    <div class="form-group">
                        <label htmlFor="schedule-start-date">Start Time</label>
                        <DatePicker
                            selected={announcement.startTime}
                            onChange={(date) => handleDateChange(date, "startTime")}
                            showTimeSelect
                            dateFormat="yyyy-MM-dd HH:mm"
                            timeFormat="HH:mm"
                            className="form-control"
                            style={{ width: "200px" }}
                            minDate={new Date()}
                        />
                    </div>
                    <div class="form-group">
                        <label htmlFor="schedule-end-date">End Time:</label>
                        <DatePicker
                            selected={announcement.endTime}
                            onChange={(date) => handleDateChange(date, "endTime")}
                            showTimeSelect
                            dateFormat="yyyy-MM-dd HH:mm"
                            timeFormat="HH:mm"
                            className="form-control"
                            style={{ width: "200px", marginLeft: "8px" }}
                            minDate={new Date()}
                            maxDate={
                                new Date(
                                    announcement.startTime.getTime() + 365 * 24 * 60 * 60 * 1000
                                )
                            }
                        //minTime={isSameDay(announcement.startTime, new Date()) ? setHours(setMinutes(new Date(), new Date().getMinutes()), new Date().getHours()) : setHours(setMinutes(new Date(), 0), 0)}
                        //new Date(announcement.startTime.getTime())}
                        //maxTime={setHours(setMinutes(announcement.startTime, 59), 23)}
                        />
                    </div>
                    {timeError && <p style={{ color: "red" }}>{timeError}</p>}

                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error}
                        </div>
                    )}
                    <Button onClick={handlePostAnnouncement} disabled={(sendTo === "policy_group" || sendTo === "device") && selectedItems.length === 0}>
                        {selectedAnnouncement ? "Update " : "Post "} {announcementTitle}
                    </Button>

                    {showDeleteDialog && (
                        <div
                            className="modal"
                            tabIndex="-1"
                            role="dialog"
                            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                        >
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Remove Image</h5>
                                        <Button onClick={() => setShowDeleteDialog(false)} variant="modal-close">
                                            &times;
                                        </Button>
                                    </div>
                                    <div className="modal-body">
                                        <p>Are you sure you want to remove this image?</p>
                                    </div>
                                    <div className="modal-footer">
                                        <Button onClick={() => setShowDeleteDialog(false)} variant="cancel">
                                            Cancel
                                        </Button>
                                        <Button onClick={() => {
                                            if (existingImage && !isImageDeleted) {
                                                handleRemoveExistingImage();
                                            } else {
                                                handleRemoveImage();
                                            }
                                        }} variant="delete">
                                            Remove
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </form>
            </div>
            <SendToModal
                visible={itemPicker}
                sendTo={sendTo}
                title={sendTo === "policy_group" ? "Groups" : "Devices"}
                searchPlaceholderText={sendTo === "policy_group" ? "groups" : "devices"}
                searchQuery={searchQuery}
                filteredItems={filteredItems}
                selectedItems={selectedItems}
                selectAll={selectAll}
                tableTitle={`Select ${sendTo === "policy_group" ? "Groups" : "Devices"
                    }`}
                handleCancel={handleCancel}
                setSearchQuery={setSearchQuery}
                handleSelectAll={handleSelectAll}
                handleItemSelect={handleItemSelect}
                handleConfirm={handleConfirm}
                isLoading={isLoadingData}
            />
        </div>
    );
}

export default Announcements;
